export default __webpack_public_path__ + "f62bbd58d96b8c37aea0accd14d998a3.png";